import React from "react";
import BJELogo from "../assets/img/Logo.svg";

export default function NavBar() {
  return (
    <header id="page-nav">
      <nav class="navbar sticky-top bg-white">
        <div class="container">
          <a class="navbar-brand" href="#">
            <img src={BJELogo} alt="Bootstrap" height="56" />
          </a>
        </div>
      </nav>
    </header>
  );
}
